document.addEventListener("DOMContentLoaded", function () {
    window.klevuOptions = {
        url: {
            landing: '/search', // your Shopify Search Results Page
            search: klevu.settings.url.protocol + '//uscs33v2.ksearchnet.com/cs/v2/search' // your Klevu APIv2 Search URL
        },
        search: {
            minChars: 0,
            searchBoxSelector: 'input[name=q],.kuSearchInput', // your Shopify Search Input
            apiKey: "klevu-169956942054016869" // your Klevu JS API Key
        },
        analytics: {
            apiKey: 'klevu-169956942054016869' // your Klevu JS API Key
        },
        theme: {
            setTemplates: [
                {
                    scope: "quick",
                    selector: "#customKlevuQuickTemplateBase",
                    name: "klevuTemplateBase"
                }
            ],

        },
        setHelpers: {
            "landing,catnav": {
                myCustomSortBy: function (dataLocal) {
                    /* sets the selected option to the display */

                    var selectedText = "";

                    var klevuStorage = klevu.getSetting(klevu.settings, "settings.storage");

                    switch (klevuStorage.sort.getElement(dataLocal) == dataLocal ? "RELEVANCE" : klevuStorage.sort.getElement(dataLocal)) {
                        case "RELEVANCE":
                            selectedText = "Best Match";
                            break;
                        case "PRICE_ASC":
                            selectedText = "Price: Low to high";
                            break;
                        case "PRICE_DESC":
                            selectedText = "Price: High to low";
                            break;
                        case "NAME_ASC":
                            selectedText = "Name: A to Z";
                            break;
                        case "NAME_DESC":
                            selectedText = "Name: Z to A";
                            break;
                        case "NEW_ARRIVAL_DESC":
                            selectedText = "Newest to Oldest";
                            break;
                        case "NEW_ARRIVAL_ASC":
                            selectedText = "Oldest to Newest";
                            break;
                        default:
                            selectedText = "Best Match";
                    }
                    return selectedText;
                }
            }
        },
        powerUp: {
            recsModule: true
        },
        recs: {
            apiKey: "klevu-169956942054016869" // your Klevu JS API key
        }
    };
    klevu(klevuOptions);
});